import React, { useState, useEffect } from 'react';
import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import moment from 'moment';

import { AddButton } from '../../../../components/common/button/CustomButtons';
import ChildHeader from '../../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../../components/common/FilterBy';
import { SearchBar } from '../../../../components/common/SearchBar';
import {
  CustomPagination,
  PersitedDatePicker,
  TableCustom,
} from '../../../../components/common';
import useDebounce from '../../../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../../../components/common/Modal';
import { useQuery } from '../../../../hooks/UseQuery';
import useConfirm from '../../../../components/common/useConfirm';
import { IData } from './helpers/interfaces';
import ViewFile from './components/ViewFile';
import formatDate from '../../../../components/common/formatDate';
import { convToTime } from '../../../../utils/helpers';

const tableHeaderObj = [
  [
    { text: 'S.NO.', rowspan: 1, colspan: 1 },
    { text: 'DATE', rowspan: 1, colspan: 1 },
    { text: 'SHIFT', rowspan: 1, colspan: 1 },
    { text: 'PERSON ON DUTY', rowspan: 1, colspan: 1 },
    { text: 'M/c No. & Name', rowspan: 1, colspan: 1 },
    // { text: 'MACHINE NUMBER', rowspan: 1, colspan: 1 },
    { text: 'Nature of Breakdown', rowspan: 1, colspan: 1 },
    { text: 'Work Done', rowspan: 1, colspan: 1 },
    { text: 'Start Time', rowspan: 1, colspan: 1 },
    { text: 'End Time', rowspan: 1, colspan: 1 },
    { text: 'Total', rowspan: 1, colspan: 1 },
    // { text: 'Complaint Recevied', rowspan: 1, colspan: 1 },
    // { text: 'Spare used', rowspan: 1, colspan: 1 },
    // { text: 'No. of spare used', rowspan: 1, colspan: 1 },
    { text: 'Attended By', rowspan: 1, colspan: 1 },
    { text: 'Remarks', rowspan: 1, colspan: 1 },
    { text: 'ACTION', rowspan: 1, colspan: 1 },
  ],
];

//const filterOptions = [{ value: 'customer_name', name: 'Customer Name' }];
//const newFilterOptions = [{ value: 'defect_name', name: 'Defect Reported' }];
const getTimeTaken = (
  complaint_rectified_at: any,
  complaint_recevied_at: any
) => {
  const h1 = new Date(complaint_recevied_at).getHours();
  const h2 = new Date(complaint_rectified_at).getHours();
  const m1 = new Date(complaint_recevied_at).getMinutes();
  const m2 = new Date(complaint_rectified_at).getMinutes();
  let hours = 0;
  let minutes = 0;
  if (m2 >= m1) {
    hours = h2 - h1;
    minutes = m2 - m1;
  } else {
    hours = h2 - h1 - 1;
    minutes = 60 - m1 + m2;
  }
  let timeTaken = '';
  if (hours === 0) timeTaken += '00';
  else {
    if (hours < 10) timeTaken += '0' + hours;
    else timeTaken += hours;
  }
  if (minutes === 0) timeTaken += ':00';
  else {
    if (minutes < 10) timeTaken += ':0' + minutes;
    else timeTaken += ':' + minutes;
  }
  return timeTaken;
};
const getTime = (time: any) => {
  const hours = new Date(time).getHours();
  const minutes = new Date(time).getMinutes();
  let t = '';
  if (hours < 10) t += '0' + hours;
  else t += hours;
  if (minutes < 10) t += ':0' + minutes;
  else t += ':' + minutes;
  return t;
};
const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [maintenaceLogId, setMaintenanceLogId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const search = useQuery('search') || '';
  const filter = useQuery('filter') || 'createdAt';
  const page = useQuery('page') || 1;
  const date = useQuery('date') || '';

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE Breakdown',
    'Are you sure you want to delete this?'
  );

  useEffect(() => {
    // axios
    //   .get('/api/customerRoutes/customerList/customerForAutoComplete')
    //   .then((res) => {
    //     if (res?.data) {
    //       const formattedData = res.data.map((customer: any) => ({
    //         name: customer.customer_name,
    //         value: customer.customer_name,
    //       }));
    //       setFilterCustomer(formattedData);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get('/api/defectRoutes/defectList/defectForAutoComplete')
    //   .then((res) => {
    //     if (res?.data) {
    //       const formattedData = res.data.map((defect: any) => ({
    //         name: defect.defect_name,
    //         value: defect.defect_name,
    //       }));
    //       setFilterDefectsReported(formattedData);
    //     }
    //   })
    //   .catch((err) => console.log(err));
  }, []);
  const fetchData = async () => {
    try {
      const res = await axios.get(
        `/api/maintenaceLogRoute/?date=${date}&page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}`
      );

      setData(res?.data?.results);
      setPerPage(res?.data?.perPage);
      setTotalPages(res?.data?.pages);
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCustomerConcern = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/maintenaceLogRoute/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [page, search, render, isModal, filter, date]);

  return (
    <>
      <ChildHeader text="MAINTENANCE LOG BOOK">
        <AddButton
          onClick={() => setIsModal(true)}
          label="NEW Maintenance Log"
        />
      </ChildHeader>
      {/* <SearchFilterContainer filter={true}>
        { <SearchBar label="Search By Customer Name" />} }
        <FilterBy
          //sx={{ width: 500 }}
          name="customer"
          label="Filter By Customer"
          options={filterCustomer}
        />
        <FilterBy
          //sx={{ width: 500 }}
          name="defects"
          label="Filter By Defects Reprted"
          options={filterDefectsReported}
        />
      </SearchFilterContainer> */}
      <Box sx={{ margin: 2 }}>
        <PersitedDatePicker label="Search By Month" views={['year', 'month']} />
      </Box>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: IData, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">
                    {item.date && formatDate(item.date)}
                  </TableCell>
                  <TableCell align="center">{item.shift}</TableCell>
                  <TableCell align="center">{item.person_on_duty}</TableCell>
                  <TableCell align="center">
                    {item.machine_id?.machine_no +
                      '-' +
                      item.machine_id?.machine_name}
                  </TableCell>
                  <TableCell align="center">
                    {item.nature_of_breakdown}
                  </TableCell>
                  <TableCell align="center">{item.work_done}</TableCell>
                  {/* <TableCell align="center">
                    {item.machine_id?.machine_no}
                  </TableCell> */}
                  <TableCell align="center">
                    {item.complaint_recevied_at &&
                      getTime(item.complaint_recevied_at)}
                  </TableCell>
                  <TableCell align="center">
                    {item.complaint_rectified_at &&
                      getTime(item.complaint_rectified_at)}
                  </TableCell>
                  <TableCell align="center">
                    {item.complaint_recevied_at &&
                      item.complaint_rectified_at &&
                      getTimeTaken(
                        item.complaint_rectified_at,
                        item.complaint_recevied_at
                      )}
                  </TableCell>
                  <TableCell align="center">{item.attended_by}</TableCell>
                  {/* <TableCell align="center">{item.work_done}</TableCell>
                  <TableCell align="center">{item?.spare_part}</TableCell>
                  <TableCell align="center">{item.spare_qty}</TableCell> */}
                  <TableCell align="center">{item.remarks}</TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setMaintenanceLogId(item?._id || '');
                          setIsModal(true);
                        }}
                      />

                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          deleteCustomerConcern(item?._id || '');
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setMaintenanceLogId(null);
          setIsModal(false);
        }}
        title="Breakdown Log"
      >
        <Create id={maintenaceLogId} setIsModal={setIsModal} />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
